<script setup>
import TeamCard from '~/components/teams/TeamCard.vue';
import {computed} from 'vue';

const props = defineProps({
  stages: {
    type: Array,
    required: true
  },
  advanceCount: {
    type: Number,
    default: 1
  }
});

// Sort stages by sort order
const sortedStages = computed(() => {
  return [...props.stages].sort((a, b) => a.sort - b.sort);
});

// Get sorted teams for a stage
const getSortedTeams = (stage) => {
  if (!stage.teams) return [];
  return [...stage.teams].sort((a, b) => a.position - b.position);
};

// Check if team advances
const isAdvancing = (team, stage) => {
  const advanceCount = stage.advanceCount || props.advanceCount;
  return team.position <= advanceCount;
};
</script>

<template>
  <div class="d-flex flex-column" style="min-width: 320px; max-width: 400px;">
    <h4 class="mb-2">Group Stages</h4>
    <div class="d-flex flex-column">
      <div
          v-for="stage in sortedStages"
          :key="stage.id"
          class="border rounded overflow-hidden bg-surface mb-4"
      >
        <!-- Group Header -->
          <div class="d-flex align-center justify-space-between pa-3 border-b bg-primary-lighten-5">
          <h4 class="text-subtitle-2 font-weight-bold">{{ stage.name }}</h4>
          <v-chip
              v-if="stage.advanceCount"
              size="x-small"
              color="primary"
              variant="flat"
          >
            Top {{ stage.advanceCount }} advance
          </v-chip>
        </div>

        <!-- Group Teams -->
        <div class="pa-2">
          <div
              v-for="team in getSortedTeams(stage)"
              :key="team.id"
              class="d-flex align-center pa-2 rounded mb-1 border-thin"
              :class="{
                'bg-success-lighten-5 border-success': isAdvancing(team, stage)
              }"
          >
            <div class="flex-1-1-0" style="min-width: 0;">
              <team-card :team="team" size="small" :expandable="false"/>
            </div>
            <div class="d-flex flex-column align-center text-center px-2">
              <span class="font-weight-bold">{{ team.totalPoints || 0 }}</span>
              <span class="text-caption" style="font-size: 8px; line-height: 1;">PTS</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
// Only custom styles that don't have Vuetify equivalents
</style>
